import { baseService } from "cortex/ui/src/service/base";

export const deviceStatsService = {
  load(deviceId: string) {
    return baseService.get(`/api/device/status/${deviceId}`);
  },
};

export default deviceStatsService;
